
import MeaPage from "../../../components/MeaPage";
import { useCallback, useRef, useState } from "react";
import { Fieldset } from "primereact/fieldset";
import { Checkbox } from "primereact/checkbox";
import ScheduleListComponent from "../schedule/components/ScheduleListComponent";
import MeaButton from "../../../components/MeaButton";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import tasksAPI from "../../../services/tasks";
import { Toast } from "primereact/toast";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import { PERMISSION_TRAINING_TASKS } from "../../../permissions";
import MeaPermissionGuard from "../../../components/MeaPermissionGuard";

const formatDateToYMD = (value) => {
  if (!value) {
    return null;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const GenerateSessionsPageContent = () => {

  const { training } = useLoaderData();

  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  //
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  //
  const toast = useRef();
  //
  const [startDate, setStartDate] = useState(
    training?.start_courses_date?.split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    training?.end_courses_date?.split("T")[0]
  );
  const [avoidHolidays, setAvoidHolidays] = useState(true);
  const handleAvoidHolidaysChange = useCallback(
    (newChecked) => setAvoidHolidays(newChecked),
    []
  );
  const [avoidVacations, setAvoidVacations] = useState(true);
  const handleAvoidVacationsChange = useCallback(
    (newChecked) => setAvoidVacations(newChecked),
    []
  );
  //
  const scheduleRef = useRef();
  //
  return (
    <>
      <MeaPage
        //breadcrumb={<SlotsBreadCrumb />}
        title="Génération des séances de cours"
        subtitle="Générer des séances de cours pour cette formation"
      >
        <ConfirmDialog group="generate-sessions" />
        <Toast ref={toast} position="bottom-center" />
        <Fieldset legend="Interval de temps" className="m-2">
          <div className="grid formgrid p-fluid">
            <div className="field mb-4 col-12 md:col-6">
              <label htmlFor="startdate" className="font-medium text-900">Date de début</label>
              <Calendar locale="fr" value={startDate ? new Date(startDate) : null} onChange={(e) => setStartDate(e.value)} dateFormat="dd/mm/yy" id="startdate" showIcon />
            </div>
            <div className="field mb-4 col-12 md:col-6">
              <label htmlFor="endDate" className="font-medium text-900">Date de Fin</label>
              <Calendar locale="fr" value={endDate ? new Date(endDate) : null} onChange={(e) => setEndDate(e.value)} dateFormat="dd/mm/yy" id="endDate" showIcon />
            </div>
          </div>
        </Fieldset>
        <Fieldset legend="A éviter" className="m-2">
          <div className="card flex flex-column gap-3">
            <div className="flex align-items-center">
              <Checkbox
                inputId="avoidHolidays"
                name="avoidHolidays"
                checked={avoidHolidays}
                onChange={(e) => handleAvoidHolidaysChange(e.checked)}
              />
              <label htmlFor="avoidHolidays" className="ml-2">
                Eviter les jours fériés
              </label>
            </div>
            <div className="flex align-items-center">
              <Checkbox
                inputId="avoidVacations"
                name="avoidVacations"
                checked={avoidVacations}
                onChange={(e) => handleAvoidVacationsChange(e.checked)}
              />
              <label htmlFor="avoidVacations" className="ml-2">
                Eviter les jours de vacances
              </label>
            </div>
          </div>
        </Fieldset>
        <Fieldset
          legend="Pour quels cours ?"
          className="m-2"
        >
          <ScheduleListComponent
            ref={scheduleRef}
            schoolId={schoolId}
            trainingId={trainingId}
            showToolbar={false}
            showTotalSelectedElements={true}
          />
        </Fieldset>
        <MeaButton
          label="Générer les séances de cours"
          className="m-2"
          loading={loading}
          onClick={(e) => {
            e.stopPropagation();
            if (loading || isConfirmVisible) {
              return;
            }
            setIsConfirmVisible(true);
            let elements = scheduleRef.current.getSelectedElements();
            const data = {
              start_date: formatDateToYMD(startDate),
              end_date: formatDateToYMD(endDate),
              schedule_items_ids: elements?.map((element) => {
                return element.id;
              }),
              avoid_holidays: avoidHolidays,
              avoid_vacations: avoidVacations,
            };
            confirmDialog({
              group: "generate-sessions",
              message:
                "Voulez-vous procéder à la génération des séances de cours?",
              header: "Confirmation",
              icon: "pi pi-info-circle",
              acceptLabel: "Oui",
              rejectLabel: "Non",
              defaultFocus: "reject",
              onHide: () => {
                setIsConfirmVisible(false);
              },
              reject: () => {
                setIsConfirmVisible(false);
              },
              accept: () => {
                setIsConfirmVisible(false);
                setLoading(true);
                toast.current.show({
                  severity: "info",
                  summary: "Info",
                  sticky: true,
                  detail: "Génération des séances de cours...",
                });
                tasksAPI
                  .GenerateTrainingSessions(
                    schoolId,
                    trainingId,
                    accessToken,
                    data
                  )
                  .then((data) => {
                    toast.current.clear();
                    toast.current.show({
                      severity: "success",
                      summary: "Succès",
                      detail: "Séances de cours générés avec succès.",
                      life: 3000,
                    });
                    navigate(
                      "/school/" + schoolId + "/admin/trainings/" + trainingId + "/sessions"
                    );
                  })
                  .catch((error) => {
                    toast.current.clear();
                    toast.current.show({
                      severity: "error",
                      summary: "Erreur",
                      detail: "Erreur de génération!",
                    });
                  })
                  .finally(() => {
                    setLoading(false);
                  });
              },
            });
          }}
        />
      </MeaPage>
    </>
  );
};

const GenerateSessionsPage = () => {
  const { schoolId, trainingId } = useParams();

  return (
    <MeaPermissionGuard
      permission={PERMISSION_TRAINING_TASKS.GENERATE_SCHEDULE_SESSIONS}
      fallbackTo={`/school/${schoolId}/admin/trainings/${trainingId}/sessions`}
    >
      <GenerateSessionsPageContent />
    </MeaPermissionGuard>
  );
};

export default GenerateSessionsPage;
